<script lang="ts">
    import { _ } from 'svelte-i18n';

    import { ApiFilterBuilder } from '@automapa/svelte-automapa-template';
    import type { Assignment } from '../Assignment';
    import { deliveryList} from '../../../../stores/store';
    import './AssignmentJobOne.css';
    import Checkbox from '../../../shared/Checkbox/Checkbox.svelte';
    import type { DisplayModeType } from './types';
    import HeaderSortableColumn from '../../../shared/HeaderSortableColumn.svelte';

    export let jobFilter: ApiFilterBuilder = new ApiFilterBuilder(null);
    export let onFilterChange: () => void = () => {};
    export let assignment: Assignment;
    export let showCheckbox: boolean = true;
    export let displayMode: DisplayModeType = 'assignmentJob';
    export let minimizeViewTimeWindow: boolean = false;
    export let disabled: boolean = false;
</script>

<div
    class="list-element delivery-list-element-checkbox list-element-header"
    class:minimizeViewTimeWindow
    class:delivery-list-element-assignmentJob={displayMode === 'assignmentJob'}
    class:delivery-list-element-routePoint={displayMode === 'routePoint'}
>
    <div class="checkbox">
        {#if showCheckbox}
            <Checkbox
                label=""
                disabled={disabled}
                checked={$deliveryList.selectMode === 'filtered'}
                onChange={v => {
                    if ($deliveryList.selectMode === 'selected') {
                        $deliveryList.selectMode = 'filtered';
                        $deliveryList.selectedOrUnselected = [];
                    } else {
                        $deliveryList.selectMode = 'selected';
                        $deliveryList.selectedOrUnselected = [];
                    }
                }}
            />
        {/if}
    </div>
    <div class="color"></div>
    <div class="address-2">
        <HeaderSortableColumn
            disabled={displayMode === 'routePoint'}
            bind:jobFilter
            {onFilterChange}
            label={$_('Address')}
            className=""
            fieldName={[
                'job.computed_address.city',
                'job.computed_address.street_for_sorting',
                'job.computed_address.house_as_number::int',
                'job.computed_address.house',
            ]}
        />
    </div>
    <div class="date-2">
        <HeaderSortableColumn
            bind:jobFilter
            disabled={displayMode === 'routePoint'}
            {onFilterChange}
            label={$_('Realisation')}
            className=""
            fieldName='job.target_date'
        />
    </div>
    <div class="status-2">
        <HeaderSortableColumn
            bind:jobFilter
            disabled={displayMode === 'routePoint'}
            {onFilterChange}
            label={$_('Status')}
            className=""
            fieldName='job.process_status'
        />
    </div>
    <div class="time-window">
        <HeaderSortableColumn
            bind:jobFilter
            disabled={true}
            {onFilterChange}
            label= {$_('Time_window')}
            className=""
            fieldName=""
        />
    </div>
    <div class="other"></div>
</div>
